import { Box } from "@mui/system";
import "./GraphSkeleton.css";
const GraphSkeleton = () => {
  return (
    <Box sx={{ px: 3, py: 2 }}>
      <div className="shimmer-box"></div>
    </Box>
  );
};

export default GraphSkeleton;
